import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';

const infrastructureSlider = document.querySelector('.j-infrastructure-slider');

if (infrastructureSlider) {
    let slider = {};
    const options = {
        modules          : [Autoplay, Navigation, Pagination],
        loop             : true,
        speed            : 800,
        spaceBetween     : 10,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 0,
        // centeredSlides      : true,
        // centeredSlidesBounds: true,
        autoplay         : {
            delay: 6000
        },
        pagination: {
            el  : '.j-infrastructure-pagination',
            type: 'custom',
            renderCustom(_, current, total) {
                const newCurrent = current < 10 ? `0${current}` : current;
                const newTotal = total < 10 ? `0${total}` : total;

                return `<span class="slider-control__current">${newCurrent}</span>
                           <span class="slider-control__total">/ ${newTotal}</span>`;
            }
        },
        navigation: {
            nextEl: '.j-infrastructure-next',
            prevEl: '.j-infrastructure-prev'
        },
        breakpoints: {
            1280: {
                allowTouchMove: false,
                spaceBetween  : 0
            }
        }
    };

    slider = new Swiper(infrastructureSlider, options);
    slider.init();
}
